<template>
  <v-row id="results">
    <v-col
      v-for="poi in filteredPois"
      :key="poi.id"
      cols="12"
      sm="6"
      lg="4"
    >
      <ResultThumbnail
        :poi="poi"
        @hoverEnter="hoverEnter"
        @hoverLeave="hoverLeave"
      />
    </v-col>
  </v-row>
</template>

<script>
  import ResultThumbnail from './ResultThumbnail'

  export default {
    name: 'ResultThumbnails',
    components: { ResultThumbnail },
    props: {
      filteredPois: {
        required: true,
        type: Array,
      },
    },

    methods: {
      hoverEnter(id) {
        this.$emit('onHover', id)
      },
      hoverLeave() {
        this.$emit('onHover', '')
      },
    },
  }
</script>

<style scoped>

</style>
